import React from 'react';
import SidebarButton from '../components/Sidebar/SidebarButton';
import { Layout, Menu } from 'antd';

const { Sider } = Layout;
const { SubMenu } = Menu;

class SiderDemo extends React.Component {
  state = {
    collapsed: true,
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  onSelect = e => {
    switch (e.key) {
      case 'portal':
        window.location.href = '/portal';
        break;
      case 'documents':
        window.location.href = '/documents';
        break;
      case 'reports':
        window.location.href = '/reports';
        break;
      case 'projects':
        window.location.href = '/projects';
        break;
      case 'advanced-search':
        window.location.href = '/search';
        break;
      case 'saved-search':
        window.location.href = '/saved-search';
        break;
      case 'messages':
        window.location.href = '/workflow?view=messages';
        break;
      case 'workflows':
        window.location.href = '/workflow?view=tasks';
        break;
      case 'workflow-history':
        window.location.href = '/workflow?view=history';
        break;        
      default:
        break;
    }
  }
  
  render() {
    return (
      // <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible width="250" collapsed={this.state.collapsed} onCollapse={this.onCollapse} collapsedWidth={50} style={{backgroundColor: '#2c343a', minHeight: '100vh'}}>
          <div className="branding"><img alt="Document Locator" className="header-logo" src="images/logo/logo.png" /></div>
          <Menu
            defaultSelectedKeys={['1']}
            defaultOpenKeys={!this.state.collapsed ? ['sub1'] : []}
            onClick={this.onSelect}
            mode="inline"
            style={{padding: '0px', backgroundColor: '#2c343a', color: '#fff', border: 'none'}}
          >
            <Menu.Item key="portal" title="Portal">
              <SidebarButton iconType="home" text="Portal"/>
            </Menu.Item>
            <Menu.Item key="documents" style={{paddingLeft: '0 !important'}} title="Documents">
              <SidebarButton iconType="file" text="Documents"/>
            </Menu.Item>
            <Menu.Item key="messages" title="Messages">
              <SidebarButton iconType="envelope" text="Messages" />
            </Menu.Item>
            <SubMenu
              key="subWorkflow"
              title={
                <SidebarButton iconType="cogs" text="Workflows" />
              }
            >
              <Menu.Item key="workflows"><SidebarButton iconType="cogs" text="Workflows" style={{marginRight:0}}/></Menu.Item>
              <Menu.Item key="workflow-history"><SidebarButton iconType="history" text="Workflow History" style={{marginRight:0}}/></Menu.Item>
            </SubMenu>
            <Menu.Item key="reports" title="Reports">
              <SidebarButton iconType="chart-bar" text="Reports" />
            </Menu.Item>
            <Menu.Item key="projects" title="Projects">
              <SidebarButton iconType="project-diagram" text="Projects" />
            </Menu.Item>
            {/* <Menu.Item key="11" title="Search">
              <SidebarButton iconType="search" text="Search" />
            </Menu.Item> */}
            <SubMenu
              key="sub1"
              title={
                <SidebarButton iconType="search" text="Searches" />
              }
            >
              <Menu.Item key="advanced-search"><SidebarButton iconType="search-plus" text="Advanced Search" style={{marginRight:0}}/></Menu.Item>
              <Menu.Item key="saved-search"><SidebarButton iconType="archive" text="Saved Searches" style={{marginRight:0}}/></Menu.Item>
              <Menu.Divider></Menu.Divider>
              

              <Menu.Item key="678"><SidebarButton iconType="history" text="Last 30 Days" style={{marginRight:0}}/></Menu.Item>
              <Menu.Item key="670"><SidebarButton iconType="history" text="Last 30 Docs" style={{marginRight:0}}/></Menu.Item>
              <Menu.Item key="99"><SidebarButton iconType="check" text="My Checked Out Docs" style={{marginRight:0}}/></Menu.Item>
              <Menu.Item key="1343"><SidebarButton iconType="cogs" text="My Workflow Tasks" style={{marginRight:0}}/></Menu.Item>
            </SubMenu>

            <Menu.Item key="9" title="Favorites">
              <SidebarButton iconType="star" text="Favorites" />
            </Menu.Item>
            <Menu.Item key="10" title="Recycle Bin">
              <SidebarButton iconType="trash" text="Recycle Bin" />
            </Menu.Item>
          </Menu>
        </Sider>
      // </Layout>
    );
  }
}

export default React.memo(SiderDemo);
          